import { CopyToClipboard } from '@delmonicos/shared-design-system-react/src/components/copy-to-clipboard/copy-to-clipboard';
import { Text } from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { GatewayChargingSessionModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/back-office-gateway-emsp-lib/src/outputs/charging-sessions/gateway-charging-session.model';
import { CellContext } from '@tanstack/react-table';

export interface EmspBoChargingSessionListTokenUidCellProps
  extends CellContext<
    GatewayChargingSessionModel,
    GatewayChargingSessionModel['tokenUid']
  > {}

export const EmspBoChargingSessionListTokenUidCell = (
  props: EmspBoChargingSessionListTokenUidCellProps,
): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { getValue } = props;

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <CopyToClipboard textToCopy={getValue()}>
      <Text truncate>{getValue()}</Text>
    </CopyToClipboard>
  );
};
